export const GAME = '/game'
export const OFFLINE = '/offline'
export const ONLINE = '/online'
export const ROOT = '/'
export const STREAMS = '/streams'
